/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DataIcon = ({ width = 24, height = 24, hidden = false, title = 'Data' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18,4.75c0-2.13379-4.02441-3.25-8-3.25S2,2.61621,2,4.75c0,.06714.01538.13037.02325.19556-.00629.03906-.02325.07422-.02325.11499v9.93945c0,2.06152,4.14697,3,8,3s8-.93848,8-3V5.06055c0-.04077-.01697-.07593-.02325-.11499.00787-.06519.02325-.12842.02325-.19556ZM16.50024,9.99451c-.0918.41516-2.22833,1.50549-6.50024,1.50549-4.27295,0-6.40967-1.09082-6.5-1.5v-3.27551c1.52985.84216,4.02393,1.27551,6.5,1.27551s4.97015-.43335,6.50006-1.27563l.00018,3.27014ZM10,3c4.28857,0,6.5,1.22656,6.5,1.75s-2.21143,1.75-6.5,1.75-6.5-1.22656-6.5-1.75,2.21143-1.75,6.5-1.75ZM10,16.5c-4.27295,0-6.40967-1.09082-6.5-1.5v-3.15356c1.55219.78394,4.08337,1.15356,6.5,1.15356,2.41681,0,4.94818-.36963,6.50031-1.15369l.00018,3.14783c-.09082.41504-2.22754,1.50586-6.50049,1.50586Z"
      fill="currentColor"
    />
  </svg>`;
};
